import axios from 'axios';
import { setupCache } from 'axios-cache-adapter';

// Créer une instance unique de cache
const cache = setupCache({
    maxAge: 60 * 60 * 1000, // 1 heure
    debug: false,
    exclude: {
        // Exclure les requêtes POST, PUT, DELETE du cache
        methods: ['post', 'put', 'delete']
    }
});

export const getCustomersAds = async (id, status = "") => {
    const ApiUrl = `${process.env.REACT_APP_PUBLIC_API}/customers/${id}/annonces${status}`;
    
    // Créer une instance temporaire avec le cache pour cette requête
    const api = axios.create({
        adapter: cache.adapter
    });
    
    // L'intercepteur global ajoutera automatiquement le token
    return api.get(ApiUrl).then((response) => response.data);
}

export const getCustomerById = async (id) => {
    const ApiUrl = `${process.env.REACT_APP_PUBLIC_API}/customers/${id}`;
    return axios.get(ApiUrl).then((response) => response.data);
}

// Alias pour la compatibilité avec l'ancien code
export const getCustomer = getCustomerById;

export const updateCustomer = async (id, customer) => {
    const ApiUrl = `${process.env.REACT_APP_PUBLIC_API}/customers/${id}`;
    return axios.put(ApiUrl, customer).then((response) => response.data);
}